import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Sidebar from './Sidebar';
import GlobalHeader from './GlobalHeader';
import GlobalFooter from './GlobalFooter';

export default function Layout() {
  const { user, loading } = useAuth();

   if (loading) {
     return (
       <div className="min-h-screen flex items-center justify-center">
         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
       </div>
     );
   }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 ml-56 flex flex-col overflow-hidden">
        <GlobalHeader />
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
        <GlobalFooter />
      </div>
    </div>
  );
}
